export default "https://assets.egbcdn.net/assets/packs/_/images/hero/hero-private-b22d7747529cc5233cc92502038d22b2.png";